//Heroku URL

export const API_URL = "https://node-plus-react-crm-app.herokuapp.com"
